import React from 'react'
import us_vs_them_img from '../assets/us_vs_them.png'

const UsVsThem = () => {
    return (
        <>
            <div className="bg-white py-6 md:py-16">
                <div className="container-custom px-4 md:px-6">
                    <div className="grid md:grid-cols-[2fr_3fr]">
                        {/* Left side - Text content */}
                        <div className="md:max-w-[85%] text-center md:text-left">
                            <h2 className="text-[#008037] text-[28px] md:text-[40px] font-semibold tracking-tighter mb-4">Us vs. Them</h2>
                            <p className="text-[15px] md:text-[18px] mb-4">
                                Not overhyped or overpriced. Just comprehensive and complete nutrition made enjoyable and for everyone.
                            </p>
                        </div>

                        {/* Right side - Image placeholder */}
                        <div className="">
                            <img src="https://cdn.shopify.com/s/files/1/0550/9614/8034/files/Gruns-ComparativeTable-Desktop_6f4d1e17-0cc0-4710-a6df-78db1cc10647.png?v=1736368012&width=1800" alt="us vs them" className="h-[350px] md:h-[500px] w-full" />
                        </div>
                    </div>
                </div>
            </div>

            {/* CTA Section */}
            <div className="bg-[#002613] py-[30px]">
                <div className="bg-[#0a2704] container-custom py-[30px] text-center">
                    <h2 className="text-white text-[23px] md:text-[30px] font-semibold mb-4 md:mb-8">
                        Want to join the 8% of people who are nutrient <em className="font-normal italic">sufficient</em>?
                    </h2>
                    <div className="relative inline-block">
                        <div className="absolute top-[5px] left-[5px] w-full h-full bg-[#fff] rounded-full"></div>
                        <button className="relative bg-[#008037] border border-[#000] text-white font-semibold py-3 md:py-4 px-10 rounded-full hover:translate-y-[1px] hover:translate-x-[1px] transition-transform duration-200 text-sm">
                            get your grüns
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default UsVsThem
